export default "__VITE_ASSET__VNeYSQLecFOVt2GTIo3IsQ__"